/* import axios from 'axios' */
import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_CONTRATOS_URL}${process.env.VUE_APP_API_PATH}`

export default {
    obterTodos(contratosFiltros) {
        return axiosJwt
            .get(
                `${api}/contratos?situacao=${
                    contratosFiltros.situacao ? contratosFiltros.situacao : ''
                }&status=${
                    contratosFiltros.status ? contratosFiltros.status : ''
                }`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterOpcoesFiltros() {
        return axiosJwt
            .get(`${api}/contratos/opcoesfiltros`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterPorId(id) {
        return axiosJwt
            .get(`${api}/contratos/${id}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterPorIdApostilar(id) {
        return axiosJwt
            .get(`${api}/contratos/${id}/apostilar`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    atualizarContrato(contrato) {
        return axiosJwt
            .post(`${api}/contratos/${contrato.idContrato}/atualizar`, contrato)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    atualizarContratoComprovacao(contrato, isTipoEspecial) {
        return axiosJwt
            .post(
                `${api}/contratos/${contrato.idContrato}/atualizarcomprovacao`,
                isTipoEspecial
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    apostilarContrato(apostilamento) {
        return axiosJwt
            .post(
                `${api}/contratos/${apostilamento.idContrato}/apostilar`,
                apostilamento
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    ajustarContrato(contrato) {
        return axiosJwt
            .post(`${api}/contratos/${contrato.idContrato}/ajustar`, contrato)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    alternarContrato(alternarContrato) {
        return axiosJwt
            .post(
                `${api}/contratos/${alternarContrato.idContrato}/alternar`,
                alternarContrato
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterApostilamentosContrato(contratoId) {
        return axiosJwt
            .get(`${api}/contratos/${contratoId}/apostilamentos`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterDotacoesPorContrato(contratoId) {
        return axiosJwt
            .get(`${api}/contratos/${contratoId}/dotacoes`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    atualizarDotacaoContrato(dotacao) {
        return axiosJwt
            .post(`${api}/contratos/${dotacao.idContrato}/dotacoes`, dotacao)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    excluirDotacaoContrato(dotacao) {
        return axiosJwt
            .patch(`${api}/contratos/${dotacao.idContrato}/dotacoes`, dotacao)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterResponsaveisPorContrato(contratoId) {
        return axiosJwt
            .get(`${api}/contratos/${contratoId}/responsaveis`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterPorIdReponsavel(id, responsavelId) {
        return axiosJwt
            .get(`${api}/contratos/${id}/responsaveis/${responsavelId}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    atualizarResponsavel(responsavel) {
        return axiosJwt
            .post(
                `${api}/contratos/${responsavel.idContrato}/responsaveis`,
                responsavel
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    excluirResponsavel(responsavel) {
        return axiosJwt
            .put(
                `${api}/contratos/${responsavel.idContrato}/responsaveis`,
                responsavel
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterSubItens(idContrato, itemContratoId) {
        return axiosJwt
            .get(
                `${api}/contratos/${idContrato}/itenscontrato/${itemContratoId}`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    atualizarItemContrato(itemContrato) {
        return axiosJwt
            .post(
                `${api}/contratos/${itemContrato.idContrato}/itenscontrato`,
                itemContrato
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    ativarDesativarItemContrato(itemContrato) {
        return axiosJwt
            .put(
                `${api}/contratos/${itemContrato.idContrato}/itenscontrato/${itemContrato.itemContratoId}/ativardesativar`,
                itemContrato
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    atualizarValoresEmLoteItemContrato(itensContrato) {
        return axiosJwt
            .put(
                `${api}/contratos/${itensContrato.idContrato}/itenscontrato/atualizarvaloresemlote`,
                itensContrato
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    atualizarQuantidadesEmLoteItemContrato(itensContrato) {
        return axiosJwt
            .put(
                `${api}/contratos/${itensContrato.idContrato}/itenscontrato/atualizarquantidadesemlote`,
                itensContrato
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterFasesPorContrato(contratoId) {
        return axiosJwt
            .get(`${api}/contratos/${contratoId}/fases`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterFasePorId(idContrato, faseContratoId) {
        return axiosJwt
            .get(`${api}/contratos/${idContrato}/fases/${faseContratoId}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    atualizarFaseContrato(faseContrato) {
        return axiosJwt
            .post(
                `${api}/contratos/${faseContrato.idContrato}/fases`,
                faseContrato
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    excluirFase(faseContrato) {
        return axiosJwt
            .post(
                `${api}/contratos/${faseContrato.idContrato}/fases/excluir`,
                faseContrato
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterDetalhesFase(idContrato, faseContratoId) {
        return axiosJwt
            .get(
                `${api}/contratos/${idContrato}/fases/${faseContratoId}/detalhes`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    atualizarDetalheFaseEntrega(detalheFase) {
        return axiosJwt
            .post(
                `${api}/contratos/${detalheFase.idContrato}/fases/${detalheFase.faseContratoId}/detalhes/entrega`,
                detalheFase
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirDetalhesFaseParcelaFixa(fase) {
        return axiosJwt
            .post(
                `${api}/contratos/${fase.idContrato}/fases/${fase.faseContratoId}/detalhes/parcelafixa/inseriremlote`,
                fase
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    excluirDetalhesFaseParcelaFixa(fase) {
        return axiosJwt
            .post(
                `${api}/contratos/${fase.idContrato}/fases/${fase.faseContratoId}/detalhes/parcelafixa/excluiremlote`,
                fase
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    atualizarDetalheFaseParcelaFixa(detalheFase) {
        return axiosJwt
            .post(
                `${api}/contratos/${detalheFase.idContrato}/fases/${detalheFase.faseContratoId}/detalhes/parcelafixa`,
                detalheFase
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    excluirDetalheFase(detalheFase) {
        return axiosJwt
            .post(
                `${api}/contratos/${detalheFase.idContrato}/fases/${detalheFase.faseContratoId}/detalhes/excluir`,
                detalheFase
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    atualizarValoresEmLoteDetalhesFase(detalhesFase) {
        return axiosJwt
            .post(
                `${api}/contratos/${detalhesFase.idContrato}/fases/${detalhesFase.faseContratoId}/detalhes/atualizarvaloresemlote`,
                detalhesFase
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    distribuirContrato(contrato) {
        return axiosJwt
            .post(`${api}/contratos/${contrato.idContrato}/distribuir`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    integrarContrato(contrato) {
        return axiosJwt
            .post(`${api}/contratos/${contrato.idContrato}/integrar`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirResponsaveisPadrao(contratoId) {
        return axiosJwt
            .patch(`${api}/contratos/${contratoId}/responsaveis/padrao`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    assinarAditivoContrato(contrato) {
        return axiosJwt
            .post(`${api}/contratos/${contrato.idContrato}/assinaraditivo`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    integrarAditivoContrato(contrato) {
        return axiosJwt
            .post(`${api}/contratos/${contrato.idContrato}/integraraditivo`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterTiposMovimentos() {
        return axiosJwt
            .get(`${api}/contratos/tiposmovimentos`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterHistoricoAditivos(contrato) {
        return axiosJwt
            .get(`${api}/contratos/${contrato.idContrato}/historicoaditivos`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterDadosRM(id) {
        return axiosJwt
            .patch(`${api}/contratos/${id}/obterdadosrm`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    voltarEtapaContrato(voltarEtapaContratoDto) {
        return axiosJwt
            .post(
                `${api}/contratos/${voltarEtapaContratoDto.idContrato}/voltaretapa`,
                voltarEtapaContratoDto
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    exportarPlanilhaSubItens(contrato) {
        return axiosJwt
            .get(
                `${api}/contratos/${contrato.idContrato}/itenscontrato/exportarplanilhasubitens`,
                {
                    responseType: 'blob'
                }
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    RemanejarValorItens(idContrato, remanejamentoDto) {
        return axiosJwt
            .put(
                `${api}/contratos/${idContrato}/itenscontrato/remanejaritens`,
                remanejamentoDto
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    ObterConsumoFasePorItem(faseId) {
        return axiosJwt
            .get(`${api}/contratos/0/fases/${faseId}/consumoporitem`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    exportarPlanilhaRequisicoesPorItem(itemId) {
        return axiosJwt
            .get(
                `${api}/contratos/${itemId}/itenscontrato/exportarconsumoitemcontrato`,
                {
                    responseType: 'blob'
                }
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    atualizarQuantidadesEmLoteItemContrato(itensContrato) {
        return axiosJwt
            .put(
                `${api}/contratos/${itensContrato.idContrato}/itenscontrato/atualizarquantidadesemlote`,
                itensContrato
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    }
}
